import { simplePath } from "../../utils.js";
const GET_USER_PINS_PATH = '/v2/user-pins/:username';
function get_user_pins_path(params) {
    return simplePath(GET_USER_PINS_PATH, params);
}
export { GET_USER_PINS_PATH, get_user_pins_path };
